export default __webpack_public_path__ + "static/media/add-note2.059f1c12.svg";